"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _generalStore = require("general-store");

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _StyledMiniProfileHighlight = require("crm_ui/profile/sidebar/highlight/mini/StyledMiniProfileHighlight");

var propTypes = {
  subject: _SubjectType.default
};

var MiniTicketHighlight =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MiniTicketHighlight, _Component);

  function MiniTicketHighlight() {
    (0, _classCallCheck2.default)(this, MiniTicketHighlight);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MiniTicketHighlight).apply(this, arguments));
  }

  (0, _createClass2.default)(MiniTicketHighlight, [{
    key: "renderTitle",
    value: function renderTitle() {
      var subject = this.props.subject;
      var title = (0, _ImmutableModel.getProperty)(subject, 'subject');
      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightTitleNoTruncate, null, title);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlight, null, _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightDetails, {
        className: "text-left m-left-6"
      }, this.renderTitle()));
    }
  }]);
  return MiniTicketHighlight;
}(_react.Component);

MiniTicketHighlight.propTypes = propTypes;

var _default = (0, _generalStore.connect)({
  subject: _SubjectDependency.default
})(MiniTicketHighlight);

exports.default = _default;
module.exports = exports.default;